
<app-default-landing-page-template *ngIf="type == 'landingPage' && template == 'default_template' ">
</app-default-landing-page-template>
<app-modern-template-landing-page *ngIf="type == 'landingPage' && template == 'modern_template' ">
</app-modern-template-landing-page>
<app-default-filter-page-template *ngIf="type == 'filterPage' && template == 'default_template' "></app-default-filter-page-template>
<app-default-package-page-template *ngIf="type == 'packagePage' && template == 'default_template' "></app-default-package-page-template>
<app-default-quick-order-template *ngIf="type == 'quickOrder' && template == 'default_template' "></app-default-quick-order-template>
<app-modren-template-quick-order *ngIf="type == 'quickOrder' && template == 'modern_template' "></app-modren-template-quick-order>
